import request, {requestJson} from '../main';
const service = ""
class AuthApi {
    private url: string = service + "/auth";

    //获取验证码拼图
    public captcha() {
        return request({
            url: this.url + '/captcha',
            method: 'get'
        })
    }
}
const authApi = new AuthApi();
export {authApi}